<template>
  <div class="results">
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-clipboard-list-outline</v-icon>
        <h1>Results</h1>
      </v-layout>
    </div>
    <div>
      <div class="right">
        <yearselect
          label="Select a Year"
          @yearChanged="onSelectedYearChanged"
        ></yearselect>
      </div>
    </div>
    <v-expansion-panels focusable hover v-model="panel">
      <v-expansion-panel v-for="event in yearEvents" :key="event.eventId">
        <v-expansion-panel-header>
          <div class="label">{{ event.title }}</div>
          <v-spacer></v-spacer>
          <div class="label-date">
            Start: {{ convertDate(event.eventStart, false) }}
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            ><v-expansion-panels>
              <v-expansion-panel
                v-for="flight in flights"
                :key="flight.flightId"
              >
                <v-expansion-panel-header>
                  <div class="label">{{ flight.name }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :hide-default-footer="hideFooter"
                    :headers="headers"
                    :items="getFlightData(flight.flightId)"
                    item-key="flight.memberWinningId"
                    :items-per-page="itemsPerPage"
                    sort-by="amount"
                    :sort-desc="sortDesc"
                  ></v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel> </v-expansion-panels
          ></v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-actions>
                  <v-row>
                      <v-spacer></v-spacer>
                      <div v-if="priviledged" class="button">
                        <v-btn
                          outlined
                          @click="onAddDocument(event.eventId)"
                        >
                          <v-icon left>mdi-text-box-plus-outline</v-icon>Add
                          Document
                        </v-btn>
                      </div>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <documents :event="event"></documents>
          </v-row>
          <v-row v-if="priviledged">
            <deletedocuments
              :event="event"
              :events="yearEvents"
              @documentdeleted="onDocumentDeleted"
            ></deletedocuments>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import EventsService from '../../services/api/EventsService.js'
import DateService from '../../services/manager/DateService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import MoneyService from '../../services/api/MoneyService.js'
import documents from '../../components/Documents'
import deletedocuments from '../../components/DeleteDocuments'
import yearselect from '../../components/YearSelect'

export default {
  name: 'Results',
  components: {
    deletedocuments,
    documents,
    yearselect
  },
  store: store,
  data() {
    return {
      events: [],
      flights: [],
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Type',
          align: 'start',
          sortable: true,
          value: 'type'
        },
        {
          text: 'Amount',
          align: 'end',
          sortable: true,
          value: 'amount'
        }
      ],
      hideFooter: true,
      itemsPerPage: 999,
      winnings: [],
      panel: [],
      yearEvents: [],
      selectedYear: new Date().getFullYear(),
      sortDesc: true
    }
  },
  created() {
    this.fetchEvents()
  },

  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },
  methods: {
    onAddDocument(eventId) {
      router.push('/documents/edit/0?eventId=' + eventId)
    },
    fetchEvents() {
      store.commit('isLoading')
      EventsService.get()
        .then(events => {
          this.events = events
          this.sortEvents()
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },
    onDocumentDeleted() {
      this.fetchEvents()
    },

    sortEvents: function() {
      var today = new Date()
      var events = []
      var minDate = new Date(this.selectedYear, 1, 1)
      var maxDate = new Date(this.selectedYear, 12, 31)
      var thisYear = new Date().getFullYear()
      if (thisYear === this.selectedYear && maxDate > today) {
        maxDate = today
      }
      this.events.forEach(event => {
        var startDate = new Date(event.eventStart)
        if (minDate <= startDate && startDate <= maxDate) {
          events.push(event)
        }
      })
      this.yearEvents = events
    },
    convertDate: function(dateString, full) {
      return DateService.convertDate(dateString, full)
    },
    onSelectedYearChanged(selectedYear) {
      this.selectedYear = selectedYear
      this.sortEvents()
    },
    getWinnings(eventId) {
      MoneyService.get(eventId)
        .then(winnings => {
          this.winnings = winnings
          this.flights = []
          for (var i = 0; i < this.winnings.length; i++) {
            var w = this.winnings[i]
            var flight = this.flights.find(f => f.flightId === w.flightId)
            if (flight === undefined) {
              if (
                !(
                  w.flight.name === 'Skins' ||
                  w.flight.name === 'Closest to the Pin'
                )
              ) {
                w.flight.name = w.flight.name.substring(4)
              }
              this.flights.push(w.flight)
            }
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },
    getFlightData(flightId) {
      var flightData = []
      for (var i = 0; i < this.winnings.length; i++) {
        var w = this.winnings[i]
        if (w.flightId === flightId) {
          var mw = {
            name: w.member.lastname + ', ' + w.member.firstname,
            type: w.winningType.winningType,
            amount: w.amount
          }
          flightData.push(mw)
        }
      }

      return flightData
    }
  },
  watch: {
    panel: function() {
      const event = this.yearEvents[this.panel]
      this.getWinnings(event.eventId)
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  padding: 5px;
  font: bolder;
}
.label-date {
  padding: 5px;
  font: bolder;
  text-align: right;
}
.right {
  float: right;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
